import { Module } from "vuex";
import { getters } from "./getters";
import { actions } from "./actions";
import { mutations } from "./mutations";
import { ViewsState } from "./types";
import { RootState } from "../types";
import { getDefaultState } from "./state";

export const state: ViewsState = getDefaultState();

const namespaced: boolean = true;

export const views: Module<ViewsState, RootState> = {
	namespaced,
	state,
	getters,
	actions,
	mutations
};
